import { PermissionsClient, PermissionsResponse } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { queryClient } from "@hooks/useGlobalState";
import { useMutation, useQuery } from "@tanstack/react-query";

const permissionsClient = new PermissionsClient(undefined, axios);

export const usePermissions = (options?: any) => {
  return useQuery<PermissionsResponse>({
    ...options,
    queryKey: ["permissions"],
    initialData: { permissions: [] },
    queryFn: async () => permissionsClient.getPermissions(),
  });
};

export const useDeletePermission = (options?: any) => {
  return useMutation<void, unknown, string>({
    ...options,
    mutationFn: (permissionId: string) => permissionsClient.deletePermission(permissionId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["permissions"] });
      options?.onSuccess?.();
    },
  });
};

